import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { waLink, WA_DEFAULT_MESSAGE } from "../config";

const LINKS = [
    { href: "#chi-sono", label: "Chi Sono" },
    { href: "#attivita", label: "Attività" },
    { href: "#progetti", label: "Progetti" },
    { href: "#contatti", label: "Contatti" },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);

    return (
        <header className="fixed top-0 inset-x-0 z-50">
            <div className="glass mx-3 mt-3 sm:mx-6 lg:mx-auto lg:max-w-6xl rounded-2xl shadow-lg shadow-sky-950/5">
                <nav
                    data-testid="main-navbar"
                    className="flex items-center justify-between px-4 sm:px-6 h-16"
                >
                    <a
                        href="#top"
                        data-testid="nav-logo-link"
                        className="flex items-center gap-3"
                    >
                        <Logo className="h-9 w-9" />
                        <span className="font-display font-bold text-[#03045E] leading-tight text-sm sm:text-base">
                            Maria Fasanella
                            <span className="block text-[10px] sm:text-xs font-semibold tracking-[0.2em] uppercase text-[#0096C7]">
                                Creator Plus
                            </span>
                        </span>
                    </a>

                    <div className="hidden md:flex items-center gap-7">
                        {LINKS.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
                                className="text-sm font-medium text-slate-600 hover:text-[#0077B6] transition-colors duration-200"
                            >
                                {l.label}
                            </a>
                        ))}
                        <a
                            href={waLink(WA_DEFAULT_MESSAGE)}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="nav-whatsapp-button"
                            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold text-white bg-[#0077B6] hover:bg-[#03045E] shadow-lg shadow-sky-500/25 transition-colors duration-300"
                        >
                            <MessageCircle className="h-4 w-4" />
                            WhatsApp
                        </a>
                    </div>

                    <button
                        data-testid="nav-mobile-toggle"
                        aria-label={open ? "Chiudi menu" : "Apri menu"}
                        onClick={() => setOpen(!open)}
                        className="md:hidden inline-flex items-center justify-center h-11 w-11 rounded-xl text-[#03045E] hover:bg-sky-100 transition-colors"
                    >
                        {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                    </button>
                </nav>

                <AnimatePresence>
                    {open && (
                        <motion.div
                            data-testid="nav-mobile-menu"
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: "auto" }}
                            exit={{ opacity: 0, height: 0 }}
                            transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
                            className="md:hidden overflow-hidden border-t border-slate-200/70"
                        >
                            <div className="px-5 py-4 flex flex-col gap-1">
                                {LINKS.map((l) => (
                                    <a
                                        key={l.href}
                                        href={l.href}
                                        onClick={() => setOpen(false)}
                                        data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(" ", "-")}`}
                                        className="py-3 text-base font-medium text-slate-700 hover:text-[#0077B6] transition-colors"
                                    >
                                        {l.label}
                                    </a>
                                ))}
                                <a
                                    href={waLink(WA_DEFAULT_MESSAGE)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="nav-mobile-whatsapp-button"
                                    className="mt-2 inline-flex items-center justify-center gap-2 px-5 py-3.5 rounded-full text-sm font-semibold text-white bg-[#0077B6]"
                                >
                                    <MessageCircle className="h-4 w-4" />
                                    Scrivimi su WhatsApp
                                </a>
                            </div>
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>
        </header>
    );
};
